import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var RoleGuard = /** @class */ (function () {
    function RoleGuard(router) {
        this.router = router;
    }
    RoleGuard.prototype.canActivate = function (route, state) {
        var adminId = localStorage.getItem('adminId');
        if (state.url.startsWith('/omnidashboard') && (adminId === null || adminId === undefined)) {
            this.router.navigate(['/di-home']);
            return false;
        }
        if (adminId === null || adminId === undefined) {
            return true;
        }
        else if (state.url === '/erg-admin-home' && (adminId.includes('1') || adminId === '1')) {
            return true;
        }
        else if (state.url.startsWith('/omnidashboard') && (adminId.includes('1') || adminId === '1')) {
            return true;
        }
        else if (state.url === '/di-home' && (adminId !== '1')) {
            return true;
        }
        else {
            this.router.navigate(['/di-home']);
            return false;
        }
    };
    RoleGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RoleGuard_Factory() { return new RoleGuard(i0.ɵɵinject(i1.Router)); }, token: RoleGuard, providedIn: "root" });
    return RoleGuard;
}());
export { RoleGuard };
